import { apiClient } from '../../axios';
import { ReqDatetime } from '../../types';
import {
  AffiliateOverviewResponse,
  AffiliateOverviewRewardsTrendParams,
  AffiliateOverviewRewardsTrendResponse,
  AffiliateStatHistoryParams,
  AffiliateStatHistoryResponse,
  AffiliateStatResponse,
  GetAffiliatePaybackCampaignsParams,
  GetAffiliatePaybackCampaignsResponse,
  GetRefereesParams,
  GetRefereesResponse,
  GetRefereesV2Params,
  GetRefereesV2Response,
  GetSubAffiliatesParams,
  GetSubAffiliatesResponse,
  KolStatHistoryParams,
  KolStatHistoryResponse,
  PatchSubAffiliateParams,
  PaybackCampaign,
  PostAffiliatePaybackCampaignBody,
  PostSubAffiliateGroupAliasParams,
  PostSubAffiliateGroupParams,
  PutAffiliatePaybackCampaignBody,
  PutSubAffiliateGroupParams,
  ReferralProgramReferralHistoryParams,
  ReferralProgramReferralHistoryResponse,
  ReferralProgramRewardHistoryParams,
  ReferralProgramRewardHistoryResponse,
  RewardHistoryParams,
  RewardHistoryResponse,
  SubAffiliateGroup,
  SubAffiliatesDetailsResponse,
} from './types';

export const getAffiliateStatApi = (params?: ReqDatetime) =>
  apiClient.get<AffiliateStatResponse>('/v1/affiliate/stats', { params });

export const getAffiliateStatHistoryApi = (params: AffiliateStatHistoryParams) =>
  apiClient.get<AffiliateStatHistoryResponse>('/v1/affiliate/stats/history', { params });

export const getKolStatHistoryApi = (params: KolStatHistoryParams) =>
  apiClient.get<KolStatHistoryResponse>('/v1/kol/stats/history', { params });

export const getRewardHistoryApi = (params: RewardHistoryParams) =>
  apiClient.get<RewardHistoryResponse>('/v1/reward/history', { params });

/** @deprecated Use getRefereesV2Api instead */
export const getRefereesApi = (params: GetRefereesParams) =>
  apiClient.get<GetRefereesResponse>('/v1/affiliate/referees', { params });

export const getRefereesV2Api = (params: GetRefereesV2Params) =>
  apiClient.get<GetRefereesV2Response>('/v1/affiliate/referees-v2', { params });

export const getSubAffiliatesApi = (params: GetSubAffiliatesParams) =>
  apiClient.get<GetSubAffiliatesResponse>('/v1/affiliate/sub-affiliates', { params });

export const patchSubAffiliateApi = ({ uid, params }: { uid: string; params: PatchSubAffiliateParams }) =>
  apiClient.patch(`/v1/affiliate/sub-affiliates/${uid}`, params);

export const getSubAffiliateGroupApi = () => apiClient.get<SubAffiliateGroup>('/v1/affiliate/sub-affiliate-group');

export const getAffiliateOverviewApi = () => apiClient.get<AffiliateOverviewResponse>('/v1/affiliate/overview');

export const getAffiliateOverviewRewardsTrendApi = (params: AffiliateOverviewRewardsTrendParams) =>
  apiClient.get<AffiliateOverviewRewardsTrendResponse>('/v1/affiliate/overview-rewards-trend', {
    params,
    timeout: 60000,
  });

export const getReferralProgramRewardHistoryApi = (params: ReferralProgramRewardHistoryParams) =>
  apiClient.get<ReferralProgramRewardHistoryResponse>('/v1/referral-program/reward-history', { params });

export const getReferralProgramReferralHistoryApi = (params: ReferralProgramReferralHistoryParams) =>
  apiClient.get<ReferralProgramReferralHistoryResponse>('/v1/affiliate/overview-referral-history', { params });

export const getReferralProgramReferralHistoryCSVApi = (
  params: Omit<ReferralProgramReferralHistoryParams, 'lastDate'>,
) => apiClient.get<string>('/v1/affiliate/overview-referral-history-csv', { params });

export const getSubAffiliatesDetailsApi = ({ uid }: { uid: string }) =>
  apiClient.get<SubAffiliatesDetailsResponse>(`/v1/affiliate/sub-affiliates/${uid}`);

// Payback Campaigns

export const getAffiliatePaybackCampaignsApi = (params?: GetAffiliatePaybackCampaignsParams) =>
  apiClient.get<GetAffiliatePaybackCampaignsResponse>('/v1/affiliate/payback-campaigns', { params });

export const postAffiliatePaybackCampaignApi = (body: PostAffiliatePaybackCampaignBody) =>
  apiClient.post<PaybackCampaign>('/v1/affiliate/payback-campaigns', body);

export const putAffiliatePaybackCampaignApi = ({ id, body }: { id: string; body: PutAffiliatePaybackCampaignBody }) =>
  apiClient.put<PaybackCampaign>(`/v1/affiliate/payback-campaigns/${id}`, body);

export const deleteAffiliatePaybackCampaignApi = (id: string) =>
  apiClient.delete(`/v1/affiliate/payback-campaigns/${id}`);
export const putSubAffiliateGroupApi = (params: PutSubAffiliateGroupParams) =>
  apiClient.put('/v1/affiliate/sub-affiliate-group', params);

export const postSubAffiliateGroupAliasApi = (params: PostSubAffiliateGroupAliasParams) =>
  apiClient.post('/v1/affiliate/sub-affiliate-group/alias', params);

export const postSubAffiliateGroupApi = (params: PostSubAffiliateGroupParams) =>
  apiClient.post('/v1/affiliate/sub-affiliate-group', params);
